import { DSText, DSTextInput } from '@vr/ds-react'
import { Controller } from 'react-hook-form'

import { FeesProps } from './type'

export const Fees = ({ methods, accountKey }: FeesProps) => {
  return (
    <>
      <Controller
        key={accountKey}
        name='taxaDeRetirada'
        control={methods.control}
        render={({ field: { onChange, value } }) => (
          <DSTextInput
            value={value}
            onChange={option => {
              onChange(option)
            }}
            placeholder='R$ 0,00'
            label='Taxa de retirada'
            currencyMask
            maxLength={13}
          />
        )}
      />
      {typeof methods.formState.errors.taxaDeRetirada?.message === 'string' && (
        <DSText as='span' size='sm' weight='semibold' color='errorLight'>
          {methods.formState.errors.taxaDeRetirada.message}
        </DSText>
      )}
    </>
  )
}
